import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4172731d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4172731d')) {
      api.createRecord('4172731d', component.options)
    } else {
      api.reload('4172731d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4172731d", function () {
      api.rerender('4172731d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/PlanCard/index.vue"
export default component.exports